export const DISABLE_FRAME = 1000
export const ENABLE_FRAME = 0
